import React, { useState } from "react";

import toast from "react-hot-toast";
import { handleProspects } from "../services/merchant";
import { useAuth } from "../context/AuthContextProvider";
import { useQueryClient } from "@tanstack/react-query";

function LevelFourDecline({ prospect, setShowDecline }) {
  const [terminalId, setTerminalId] = useState("");
  const [merchantId, setMerchantId] = useState("");
  const [merchantIdentifier, setMerchantIdentifier] = useState("");
  const [comment, setComment] = useState("");
  const { user } = useAuth();
  const queryClient = useQueryClient();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await handleProspects({
        approvedBy: user.firstName + " " + user.lastName,
        approved: false,
        approvalLevel: prospect.approvalLevel,
        comment,
        onboardingId: prospect.onboardingId,
        businessType: prospect.businessType,
        merchantId: prospect.merchantId,
        terminalId,
        merchantIdentifier,
      });
      toast.success(res.message);
      setShowDecline(false);
      queryClient.invalidateQueries({ queryKey: ["fetchLvlProspects"] });
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message);
      }
    }
  };

  return (
    <>
      <div className="fixed inset-0 z-50 overflow-auto bg-black bg-opacity-50 flex justify-center items-center">
        <div className="modal-content flex flex-col justify-center h-fit w-[400px] bg-white p-6 rounded shadow-lg relative">
          <button
            className="close absolute top-3 right-2 py-1 cursor-pointer px-4 text-orange-400 border border-orange-400 rounded-md"
            onClick={() => setShowDecline(false)}
          >
            x
          </button>

          <form className="flex flex-col" onSubmit={handleSubmit}>
            <div className="flex flex-col gap-4 mt-8">
              <div className="flex flex-col">
                <label htmlFor="comment">Comment</label>
                <textarea
                  name="comment"
                  placeholder="Leave a comment.."
                  required
                  onChange={(e) => setComment(e.target.value)}
                  className="w-[350px] h-[150px] bg-gray-100 outline-none pt-7 px-2 rounded-[.5rem] pl-[.5rem] mt-3"
                />
              </div>
            </div>
            <button
              type="submit"
              className=" flex items-center justify-center bg-primary px-4 mt-8 text-white py-2 mr-2 rounded-md"
            >
              Decline
            </button>
          </form>
        </div>
      </div>
    </>
  );
}

export default LevelFourDecline;
